// extracted by mini-css-extract-plugin
module.exports = {"page_header_branding":"styles_page_header_branding__4BJ_q"};